<template>
<section>
    <div class="columns">
    </div>
    <div class="columns">
      <div class="column">
        <div class="block">
          <b-radio v-for="presetType in presetTypes"
            v-model="activePresetType"
            :native-value="presetType"
            @input="changePresetType"
            :key="presetType">
            {{ presetType | humanize }}
          </b-radio>
        </div>
      </div>
    </div>
    <div class="box" v-for="userType in userTypes" :key="userType">
      <b-field :label="userType | humanize">
      </b-field>
      <div class="block">
        Default Route
        <b-field>
          <b-input v-model="derivedValue[userType].defaultRoute">
          </b-input>
        </b-field>
        <b-checkbox
          v-for="action in actions"
          v-model="derivedValue[userType].actions"
          :native-value="action"
          :key="action"
        >
        {{ action | humanize }}
        </b-checkbox>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'c-user-permissions',
  props: ['value'],
  data() {
    return {
      activePresetType: null,
      activeUserTypes: [],
      userTypes: [
        'guest',
        'player',
        'manager',
        'agentplayer',
        'masteragent',
        'supermasteragent',
        'telegramagentplayer',
        'telegrammasteragent',
        'telegramsupermasteragent',
      ],
      presetTypes: ['sportsbook', 'shop', 'exchange'],
      actions: [
        'seeLoginForm',
        'seeRegistrationPage',
        'seeBalanceLink',
        'seeAccountLink',
        'seeAccountPage',
        'seeLogoutLink',
        'placeBet',
      ],
      emptyUserData: {
        defaultRoute: '/',
        actions: [],
      },
    }
  },
  computed: {
    derivedValue() {
      this.userTypes.forEach(userType => {
        if (!this.hasUserType(this.value, userType)) {
          this.setEmptyUser(this.value, userType)
        }
      })
      return this.value
    },
    emptyValue() {
      return this.userTypes.reduce((value, userType) => {
        return this.setEmptyUser(value, userType)
      }, {})
    },
  },
  methods: {
    changePresetType(presetType) {
      const presets = {
        sportsbook: {
          guest: {
            defaultRoute: '/',
            actions: ['seeLoginForm', 'seeRegistrationPage'],
          },
          player: {
            defaultRoute: '/',
            actions: ['placeBet', 'seeAccountLink', 'seeAccountPage', 'seeBalanceLink', 'seeLogoutLink'],
          },
        },
        shop: {
          guest: {
            defaultRoute: '/',
            actions: ['seeLoginForm'],
          },
          player: {
            defaultRoute: '/',
            actions: ['placeBet', 'seeAccountLink', 'seeAccountPage', 'seeBalanceLink', 'seeLogoutLink'],
          },
          manager: {
            defaultRoute: '/',
            actions: ['seeBalanceLink', 'seeLogoutLink'],
          },
        },
        exchange: {
          guest: {
            defaultRoute: '/',
            actions: ['seeLoginForm'],
          },
          player: {
            defaultRoute: '/',
            actions: ['placeBet', 'seeAccountLink', 'seeAccountPage', 'seeBalanceLink', 'seeLogoutLink'],
          },
        },
      }

      this.$emit('input', { ...presets[presetType] })
    },
    isUserTypeActive(userType) {
      return this.activeUserTypes.includes(userType)
    },
    hasUserType(value, userType) {
      return value[userType] && value[userType].defaultRoute && value[userType].actions
    },
    setEmptyUser(value, userType) {
      value[userType] = Object.assign({}, this.emptyUserData)
      return value
    },
  },
}
</script>

<style>
.disabled {
  background-color: gainsboro
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/Form/Custom/UserPermissions.vue